import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import '../../assets/css/auth.css';
import logo from '../../assets/images/logo.png';
import { SignupApi } from '../../Redux/Auth/Auth_Action';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const SignUp = () => {

    let navigate = useNavigate();
    const dispatch = useDispatch();
    const [state, setState] = useState({
        fname: "",
        lname: "",
        email: "",
        phone: "",
        password: "",
        cpassword: ""
    });

    const InputVal = (e) => {
        let { name, value } = e.target;
        setState({ ...state, [name]: value });
    }

    let signupData = {
        first_name: state.fname,
        last_name: state.lname,
        email: state.email,
        password: state.password,
        confirm_password: state.cpassword,
        phone_no: state.phone,
    }


    const SubmitSignUp = (e) => {
        e.preventDefault();
        dispatch(SignupApi(signupData))
            .then((res) => {
                setTimeout(() => {
                    navigate('/signin');
                }, 8000);
            })
            .catch((e) => console.log(e));
    }

    return (
        <div className='authentication signup pos-rel'>
            <span onClick={() => { navigate(-1) }} className='bck_btn'><ArrowBackIosIcon /> Back</span>
            <div className='auth-box-container'>
                <div className='auth-box-signup'>
                    <form onSubmit={SubmitSignUp}>
                        <div className='row'>
                            <div className='col-lg-2 align-self-center'>

                            </div>
                            <div className='col-lg-8 pt-3 mb-4 text-center'>

                                <img onClick={() => { navigate('/') }} className='logo-top mt-5 cursor_pointer' src={logo} />
                            </div>
                            <div className='col-lg-12 mt-4 text-center'>
                                <p className='f-mon-bold f-45 mb-3 mb-rez-0-auth-head'>Sign Up</p>
                                <p className='mb-0 f-28 f-mon-reg'>Welcome Back to <span className='f-mon-bold'>Prediction Dog</span> </p>
                                <p className='mb-0 f-25 f-mon-reg lh-01'>
                                    Where You will get betting tips
                                </p>
                                <p className='f-16 f-mon-reg mb-4 mt-2'>Already a Member ? <span onClick={() => { navigate("/signin") }} className='grn_clr ml-1 highlightx f-20'> Sign In</span></p>
                            </div>
                            <div className='col-lg-6 pr-2 pad-rez'>
                                <input
                                    onChange={InputVal} required
                                    name='fname' value={state.fname}
                                    type='text' placeholder='First Name' className="form-control f-16 f-mon-reg mt-4 rounded-0 inpt-fld-auth" />
                            </div>
                            <div className='col-lg-6 pl-2 pad-rez'>
                                <input
                                    onChange={InputVal}
                                    name='lname' value={state.lname} required
                                    type='text' placeholder='Last Name' className="form-control mt-4 f-16 f-mon-reg rounded-0 inpt-fld-auth" />
                            </div>
                            <div className='col-lg-6 pr-2 pad-rez'>
                                <input
                                    onChange={InputVal}
                                    name='email' value={state.email} required
                                    type='email' placeholder='Email' className="form-control f-16 f-mon-reg mt-4 rounded-0 inpt-fld-auth" />
                            </div>
                            <div className='col-lg-6 pl-2 pad-rez'>
                                <input
                                    onChange={InputVal}
                                    name='phone' value={state.phone} required
                                    type='number' mixlength="10" placeholder='Phone' className="no_arrow_tel form-control mt-4 f-16 f-mon-reg rounded-0 inpt-fld-auth" />
                            </div>
                            <div className='col-lg-6 pr-2 pad-rez'>
                                <input
                                    onChange={InputVal}
                                    name='password' value={state.password} required
                                    type='password' placeholder='Password' className="form-control f-16 f-mon-reg mt-4 rounded-0 inpt-fld-auth" />
                            </div>
                            <div className='col-lg-6 pl-2 pad-rez'>
                                <input
                                    onChange={InputVal}
                                    name='cpassword' value={state.cpassword} required
                                    type='password' placeholder='Confirm Password' className="form-control mt-4 f-16 f-mon-reg rounded-0 inpt-fld-auth" />
                            </div>
                            <div className='col-lg-12 text-center mt-3'>
                                <button type='submit' className='btn btn-light bt-auth-signup'>SIGN UP</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default SignUp